import { css } from 'lit';
export default css`:host{display:none}:host([selected]){display:block}.tab-panel{position:relative;display:block}
`;
